import CommonModalFactory from '@/plugins/ModalFactory';
import { message } from 'antd';
import { useEffect } from 'react';

export const openDeleteModal = CommonModalFactory<{
  api: any;
  content: string;
}>(
  {
    title: '确定删除吗？',
    okText: '删除',
  },
  ({ setOkFn, data }) => {
    const { api, content } = data || {};
    useEffect(() => {
      setOkFn(async () => {
        await api();
        message.success('删除成功');
      });
    }, [api]);
    return <>{content}</>;
  }
);

export const openConfirmModal = CommonModalFactory<{
  params: any;
  content: any;
  confirmApi: (data: any) => Promise<any>;
  cancelApi: (data: any) => Promise<any>;
}>(
  {
    title: '确认',
  },
  ({ setOkFn, data, setCancelFn }) => {
    const { content, confirmApi, cancelApi } = data || {};
    useEffect(() => {
      if (!confirmApi) return;
      setOkFn(async () => {
        return await confirmApi(data?.params);
      });
      setCancelFn(async () => {
        if (!cancelApi) return;
        await cancelApi(data?.params);
      });
    }, [data]);
    return <>{content}</>;
  }
);
